// import {post, postfile, downFile} from './http'
import {post, postfile, postJson} from './http'
const baseUrl = '/api'

// 获取题库分类列表，按elementui树结构返回，代码需支持无限级，使用递归算法
export const getAllHostcatalog = v => post(`${baseUrl}/admin/kmc/question/getAllHostcatalog`, v.data, v.success, v.error)
// 获取题库试题信息列表，只获取状态正常的数据
export const getAllQuestionInfo = v => post(`${baseUrl}/admin/kmc/question/getAllQuestionInfo`, v.data, v.success, v.error)
// 删除试题信息(可批量)
export const deleteQuestion = v => post(`${baseUrl}/admin/kmc/question/deleteQuestion`, v.data, v.success, v.error)
// 复制试题信息
export const copyQuestion = v => post(`${baseUrl}/admin/kmc/question/copyQuestion`, v.data, v.success, v.error)
// 转移试题分类
export const moveQuestionToCate = v => post(`${baseUrl}/admin/kmc/question/moveQuestionToCate`, v.data, v.success, v.error)
// 试题导入
export const importQuestionFile = v => postfile(`${baseUrl}/admin/kmc/question/importQuestionFile`, v.data, v.success, v.error)

// export const qiniuFormUpload = v => postfile(v.url, v.data, v.success, v.error)
// export const exportReportNameList = v => downFile(`${baseUrl}/admin/kmc/report/exportList`, v.data, v.success, v.error)

// 添加分类信息
export const addNewCate = v => post(`${baseUrl}/admin/kmc/question/addNewCate`, v.data, v.success, v.error)

// 删除分类信息
export const deleteCateInfo = v => post(`${baseUrl}/admin/kmc/question/deleteCateInfo`, v.data, v.success, v.error)

// 编辑分类信息
export const updateCateInfo = v => post(`${baseUrl}/admin/kmc/question/updateCateInfo`, v.data, v.success, v.error)

// 转移试题分类
export const moveCateInfo = v => post(`${baseUrl}/admin/kmc/question/moveCateInfo`, v.data, v.success, v.error)

// 编辑或新建试题信息
export const saveOrUpdateQuestionInfo = v => post(`${baseUrl}/admin/kmc/question/saveOrUpdateQuestionInfo`, v.data, v.success, v.error)

// 获取试题信息
export const getQuestionInfo = v => post(`${baseUrl}/admin/kmc/question/getQuestionInfo`, v.data, v.success, v.error)

// 获取题库详情（用于编辑回填）
export const getQuestionbankDetail = v => post(`${baseUrl}/admin/kmc/questionbank/getQuestionbankDetail`, v.data, v.success, v.error)

// 新增或编辑题库
export const getQuestionbankInfo = v => post(`${baseUrl}/admin/kmc/questionbank/getQuestionInfo`, v.data, v.success, v.error)

// 获取题库列表
export const getAllQuestionbankInfo = v => post(`${baseUrl}/admin/kmc/questionbank/getAllQuestionbankInfo`, v.data, v.success, v.error)

// 修改题库状态信息
export const updateQuestionbankStatus = v => post(`${baseUrl}/admin/kmc/questionbank/updateQuestionbankStatus`, v.data, v.success, v.error)

// 题库章节设置详情
export const getQuestionSectionDetail = v => post(`${baseUrl}/admin/kmc/questionbank/getQuestionSectionDetail`, v.data, v.success, v.error)

// 题库章节设置新增或编辑
export const saveOrUpdateQuestionSection = v => post(`${baseUrl}/admin/kmc/questionbank/saveOrUpdateQuestionSection`, v.data, v.success, v.error)

// 章节设置选择试卷
export const getAllExampaperInfo = v => post(`${baseUrl}/admin/kmc/exampaper/getAllExampaperInfo`, v.data, v.success, v.error)

// 获取考试列表
export const getAllUserexamInfo = v => post(`${baseUrl}/admin/kmc/questionbank/getAllUserexamInfo`, v.data, v.success, v.error)

// 获取题库分类信息
export const getCatelist = v => post(`${baseUrl}/admin/kmc/questionbank/getCatelist`, v.data, v.success, v.error)

// 新增或编辑题库
export const saveOrUpdateQuesbank = v => post(`${baseUrl}/admin/kmc/questionbank/saveOrUpdateQuesbank`, v.data, v.success, v.error)

// 复制题库
export const copyQuestionInfo = v => post(`${baseUrl}/admin/kmc/questionbank/copyQuestionInfo`, v.data, v.success, v.error)

// 获取题库资料列表
export const getQBDocList = v => post(`${baseUrl}/admin/kmc/questionbank/getQBDocList`, v.data, v.success, v.error)

// 删除题库资料
export const deleteQBDoc = v => post(`${baseUrl}/admin/kmc/questionbank/deleteQBDoc`, v.data, v.success, v.error)

// 提交题库资料
export const saveQBDocInfo = v => post(`${baseUrl}/admin/kmc/questionbank/saveQBDocInfo`, v.data, v.success, v.error)

// 专题/api
export const getAllQuestionbanktopicinfo = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getAllQuestionbanktopicinfo`, v.data, v.success, v.error)
export const getQuestionbanktopicconfig = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbanktopicconfig`, v.data, v.success, v.error)
export const getQuestionbanktopiccontent = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbanktopiccontent`, v.data, v.success, v.error)
export const uploadQuestionbanktopiccontent = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/uploadQuestionbanktopiccontent `, v.data, v.success, v.error)
export const getQuestionbanktopiccontentDetail = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbanktopiccontentDetail `, v.data, v.success, v.error)
export const uploadQuestionbanktopiccontentStatus = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/uploadQuestionbanktopiccontentStatus `, v.data, v.success, v.error)
export const getQuestionbankuserinfo = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbankuserinfo `, v.data, v.success, v.error)
export const getAllQuestionbankindexsection = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getAllQuestionbankindexsection `, v.data, v.success, v.error)
export const uploadQuestionbanktopicsection = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/uploadQuestionbanktopicsection `, v.data, v.success, v.error)
export const deleteQuestionbanktopicsection = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/deleteQuestionbanktopicsection `, v.data, v.success, v.error)
export const uploadQuestionbanktopicsectionindex = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/uploadQuestionbanktopicsectionindex `, v.data, v.success, v.error)
export const getAllQuestionbankindexsectiontask = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getAllQuestionbankindexsectiontask `, v.data, v.success, v.error)
export const uploadQuestionbanktopicsectiontask = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/uploadQuestionbanktopicsectiontask `, v.data, v.success, v.error)
export const getQuestionbanktopicsectiontask = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbanktopicsectiontask `, v.data, v.success, v.error)
export const getQuestionbanktopicsection = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbanktopicsection `, v.data, v.success, v.error)
export const deleteQuestionbanktopicsectiontask = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/deleteQuestionbanktopicsectiontask `, v.data, v.success, v.error)
export const getQuestionbankuserpunchinfo = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbankuserpunchinfo `, v.data, v.success, v.error)
export const getQuestionbankuserexaminfo = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbankuserexaminfo `, v.data, v.success, v.error)
export const getQuestionbankexaminfo = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbankexaminfo `, v.data, v.success, v.error)
export const getQuestionbanktopicinfo = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbanktopicinfo `, v.data, v.success, v.error)
export const getQuestionbanktopicinfoByexam = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbanktopicinfoByexam `, v.data, v.success, v.error)
export const getQuestionbanktopicdocumentinfo = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbanktopicdocumentinfo `, v.data, v.success, v.error)
export const deleteQuestionbanktopicdocumentinfo = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/deleteQuestionbanktopicdocumentinfo `, v.data, v.success, v.error)
export const uploadQuestionbanktopicdocumentinfo = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/uploadQuestionbanktopicdocumentinfo `, v.data, v.success, v.error)
// 按考证类型获取各种类型的题库设置
export const getQuestionbankTopicQBList = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbankTopicQBList `, v.data, v.success, v.error)
// 设置章节练习对应题库
export const setQuestionbankTopicChapter = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/setQuestionbankTopicChapter `, v.data, v.success, v.error)
// 删除真题/模拟对应题库
export const deleteQuestionbankTopicQB = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/deleteQuestionbankTopicQB `, v.data, v.success, v.error)
// 获取专题题库用户列表V2 
export const getQuestionbankuserinfoV2 = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbankuserinfoV2 `, v.data, v.success, v.error)
// 获取专题题库用户开通科目记录列表
export const getQuestionbankUserSubjectList = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/getQuestionbankUserSubjectList `, v.data, v.success, v.error)
// 获取所有订单列表
export const getTopicQuestionbankOrderList = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/order/getTopicQuestionbankOrderList`, v.data, v.success, v.error)
// 获取专题题库用户订单详情 code=Orderno
export const getTopicQuestionbankOrderDetail = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/order/getTopicQuestionbankOrderDetail`, v.data, v.success, v.error)
// 修改专题题库用户订单状态 code=Orderno
export const updateTopicQuestionbankOrderStatus = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/order/updateTopicQuestionbankOrderStatus`, v.data, v.success, v.error)
// 设置专题题库用户订单完成
export const updateTopicQuestionbankOrderFinish = v => postJson(`${baseUrl}/admin/kmc/questionbanktopic/order/updateTopicQuestionbankOrderFinish`, v.data, v.success, v.error)